/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Credentials_Reset_DescInputs */



/**
* | output |
* | --- |
* | "A new recovery code was issued for the member. All of their passkeys and active sessions were invalidated, so they must sign in again." |
*
* @param {Audit_Details_Member_Credentials_Reset_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_credentials_reset_desc = /** @type {((inputs?: Audit_Details_Member_Credentials_Reset_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Credentials_Reset_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Für das Mitglied wurde ein neuer Wiederherstellungscode ausgestellt. Alle Passkeys und aktiven Sitzungen wurden ungültig, das Mitglied muss sich neu anmelden.")
	return /** @type {LocalizedString} */ ("A new recovery code was issued for the member. All of their passkeys and active sessions were invalidated, so they must sign in again.")
});